import { FormattedMessage } from 'react-intl'

interface OperationErrorMessageProps {
  error: Error | null
}

export default function OperationErrorMessage({
  error
}: OperationErrorMessageProps) {
  return (
    <div role="alert" className="operation-error">
      <h3>
        <FormattedMessage id="operation-editor.error.unexecutable.title" />
      </h3>
      <p>
        <FormattedMessage id="operation-editor.error.unexecutable.description" />
      </p>
      {__DEV__ && <pre>{error?.message}</pre>}
    </div>
  )
}
